import React from "react";
import {
  Modal,
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemText
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import theme from "../../../components/LayoutComponents/theme";

export default function CoursesCard({
  open,
  onClose,
  programCourses = [],
  courses = [],
  courseSkills = {},
  programName = "",
  jobSkills = [],
  userSkills = []
}) {
  if (!open) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: 700,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
          maxHeight: "80vh",
          overflowY: "auto"
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
          <IconButton onClick={onClose}>
            <CloseIcon sx={{ color: theme.colors.purple }} />
          </IconButton>
        </Box>

        <Typography variant="h6" fontWeight="bold" gutterBottom>
          {"Courses for Program: " + programName}
        </Typography>

        {programCourses.map((pc) => {
          const course = courses.find((c) => c.courseId === pc.courseId);
          if (!course) return null;

          const skillsForCourse = courseSkills[course.courseId] || [];

          // Only show skills that are in jobSkills but not in userSkills
          const relevantSkills = skillsForCourse.filter((skill) => {
            const isJobSkill = jobSkills.some(
              (js) => js.compId === skill.compId
            );
            const isUserSkill = userSkills.some(
              (us) => us.compId === skill.compId
            );
            return isJobSkill && !isUserSkill;
          });

          // Calculate percentage improvement
          const percentageImprovement =
            jobSkills.length > 0
              ? ((relevantSkills.length / jobSkills.length) * 100).toFixed(1)
              : 0;

          return (
            <Card
              key={course.courseId}
              sx={{ maxWidth: "100%", mb: 2, p: 2, boxShadow: 3 }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1
                  }}
                >
                  <Typography variant="subtitle1" fontWeight="bold">
                    {course.courseCode} - {course.courseName}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ color:theme.colors.green, fontWeight: theme.typography.fontWeightBold }}
                  >
                    {percentageImprovement}% Improvement
                  </Typography>
                </Box>

                <Typography variant="body2" color="textSecondary">
                  Credit Hours: {course.creditHours} | Contact Hours:{" "}
                  {course.contactHours}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  {course.courseDescription}
                </Typography>
                <Box sx={{mt:'1rem'}}>
                {relevantSkills.length > 0 && <Typography variant="title1" fontWeight={theme.typography.fontWeightBold} sx={{color:theme.colors.purple}}>
                  These are the skills required by the job posting and offered by this course: 
                </Typography>}
                {/* Skills list */}
                {relevantSkills.length > 0 ? (
                  <List dense>
                    {relevantSkills.map((skill) => (
                      <ListItem key={skill.xWalkId} sx={{ py: 0.5, pl: 0 }}>
                        <ListItemText
                          primary={skill.compDescription}
                          primaryTypographyProps={{
                            sx: {
                              color: theme.colors.purple,
                              fontWeight: theme.typography.fontWeightBold
                            }
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>                  
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    No missing job skills covered by this course.
                  </Typography>
                )}
                </Box>
              </CardContent>
            </Card>
          );
        })}
      </Box>
    </Modal>
  );
}
